module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelMaintenance[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelInterventionTime[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.workTime),
      expression: "workTime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Hr"
    },
    domProps: {
      "value": (_vm.workTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.workTime = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveChannelCommentLog()
      }
    }
  }, [(_vm.commentIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-comment fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a647957","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/SubComponents/ChannelMaintenanceAddForm.vue
// module id = 1481
// module chunks = 4